<template>
  <v-container>
    <v-row v-for="(item, index) in metas" v-bind:key="index">
      <v-col
        md="6"
        xs="12"
        :style="
          'text-align: left; color: ' + $vuetify.theme.defaults.dark.accent
        "
      >
        <h3>{{ item.keyName }}</h3>
      </v-col>
      <v-col md="4" xs="10" style="text-align: left"
        ><h4>{{ item.value }}</h4></v-col
      >
      <v-col md="2" xs="2" style="text-align: left">
        <v-btn
          type="button"
          color="error"
          icon
          fab
          :disabled="deleteDisabled"
          @click.prevent="removeMeta(item.deviceMetaId)"
          ><v-icon>mdi-delete</v-icon></v-btn
        >

        <confirm-delete-dialog></confirm-delete-dialog>
      </v-col>
    </v-row>
    <v-form :lazy-validation="true" @submit.prevent="submit" v-model="valid">
      <v-row>
        <v-col cols="12" md="5" xs="12">
          <v-text-field
            :label="$t('device.meta.keyName')"
            name="keyName"
            prepend-icon="mdi-domain"
            v-model="keyName"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="5" xs="12">
          <v-text-field
            :label="$t('device.meta.value')"
            name="value"
            prepend-icon="mdi-domain"
            v-model="value"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2" xs="12">
          <v-btn color="accent" type="submit" block x-large>{{
            $t("common.create")
          }}</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "DeviceMetaForm",

  props: {
    deviceId: {
      default: null,
      require: true,
    },
  },

  data() {
    return {
      valid: false,
      keyName: "",
      value: "",
      deleteDisabled: false,
    };
  },

  methods: {
    ...mapActions("devices", ["createMeta", "deleteMeta", "getMetas"]),

    async submit() {
      var payload = {
        keyName: this.keyName,
        value: this.value,
      };

      await this.createMeta({ deviceId: this.deviceId, payload: payload });
      await this.getMetas(this.deviceId);
    },

    async removeMeta(deviceMetaId) {
      this.deleteDisabled = true;
      await this.deleteMeta(deviceMetaId);
      await this.getMetas(this.deviceId);
      this.deleteDisabled = false;
    },
  },

  computed: {
    ...mapState("devices", ["metas"]),
  },

  async created() {
    this.getMetas(this.deviceId);
  },
};
</script>
